import { defineStore } from "pinia";

type Location = "store" | "shopfloor";

type SettingsState = {
  location: Location;
  store_types: string[];
};

const stateDefault: SettingsState = {
  location: "shopfloor",
  store_types: [],
};

export const useSettingsStore = defineStore("settings", {
  state: () => stateDefault,
  actions: {
    setLocation(location: string) {
      this.location = location;
    },
    setStoreTypes(store_types: string[]) {
      this.store_types = store_types;
    },
    storeTypeIsSelected(store_type: string) {
      return this.store_types.some((item) => item.toLowerCase() === store_type.toLowerCase());
    },
  },
});
